import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateTestimonialSection } from "../../api/apiTestimonialSection";
import parseError from "../../utils/parseError";

export const useUpdateTestimonialSection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateTestimonialSection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["testimonial-section"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث بيانات الشهادات" : "Testimonial section updated")
            );
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || (isArabic ? "تعذر التحديث" : "Failed to update"));
        },
    });

    return mutation;
};
